// Feed to dryer (wet cake)
export function dryerFeed ({ dewateringCapacity, operatingHours, cakeMoisture }) {
  return dewateringCapacity * operatingHours * 100 / (100 - cakeMoisture)
}

// Output from the dryer
export function dryerOutput ({ dewateringCapacity, operatingHours, cakeMoistureAfterDryer }) {
  return dewateringCapacity * operatingHours * 100 / (100 - cakeMoistureAfterDryer)
}

// Water evaporated in the dryer
export function evaporation ({ dryerFeed, dryerOutput }) {
  return dryerFeed - dryerOutput
}

// Energy required (GJ)
export function energyRequired ({ dryerEfficiency, evaporation, heatEnergyRequired }) {
  return evaporation * heatEnergyRequired / 1000 / (dryerEfficiency / 100)
}

//
export function costPerYear ({ energyRequired, energyCost }) {
  if (isNaN(energyRequired) || isNaN(energyCost)) {
    return null
  }
  return energyRequired * energyCost
}

//
export function annualSaving (current, upgraded) {
  if (!current || !upgraded) {
    return null
  }
  if (isNaN(current.costPerYear) || isNaN(upgraded.costPerYear)) {
    return null
  }
  return current.costPerYear - upgraded.costPerYear
}

// Tonnes water to be evaporated (10 dry tonnes per hour)
export function evaporatedWater ({ cakeMoisture, dryerCapacity, cakeMoistureAfterDryer }) {
  return dryerCapacity / (100 - (cakeMoisture - cakeMoistureAfterDryer)) * 100 - dryerCapacity
}

// increased dryer capacity
export function increasedDryerCapacity ({ dryerCapacity, productionIncrease }) {
  return dryerCapacity * productionIncrease / 100 + dryerCapacity
}

// Potential increase in dryer solids loading
export function productionIncrease (current, upgraded) {
  if (!current || !upgraded) {
    return null
  }
  if (isNaN(current.evaporatedWater) || isNaN(upgraded.evaporatedWater)) {
    return null
  }
  return (current.evaporatedWater / upgraded.evaporatedWater * 100) - 100
}

// Total liquid (filtrate + wash filtrate)
export function liquid ({ cakeMoisture, washWater, dewateringCapacity, solidsInFeed }) {
  return (100 * dewateringCapacity / solidsInFeed - dewateringCapacity) - (100 * dewateringCapacity / (100 - cakeMoisture) - dewateringCapacity) + washWater
  // old calc return 100 * dewateringCapacity / (100 - cakeMoisture) - dewateringCapacity + washWater
}

// Total solids in this liquid
export function solidsInLiquid ({ liquid, solidsContent }) {
  return liquid * solidsContent / 1000
}

// Value of solids lost in filtrate (€/h)
export function lostSolidsPerHour ({ solidsInLiquid, sellingPrice }) {
  return sellingPrice * solidsInLiquid / 1000
}
// Value of solids lost in filtrate (€/a)
export function lostSolids ({ lostSolidsPerHour, sellingPrice, operatingHours }) {
  return lostSolidsPerHour * operatingHours
}

// Potential annual reduction in losses
export function wasteReduction (current, upgraded) {
  if (!current || !upgraded) {
    return null
  }
  if (isNaN(current.lostSolids) || isNaN(upgraded.lostSolids)) {
    return null
  }
  return current.lostSolids - upgraded.lostSolids
}



// WEBPACK FOOTER //
// ./src/starch-math.js